import type { IUseCase } from 'shared-kernel';
import type { IAuthRepository } from '../../../domain/ports';
import type { VerifyEmailChangeData } from '../../dto/dtos';

export class VerifyEmailChangeUseCase implements IUseCase<VerifyEmailChangeData, void> {
  constructor(
    private readonly authRepository: IAuthRepository,
  ) {}

  async execute(input: VerifyEmailChangeData): Promise<void> {
    const response = await this.authRepository.verifyEmailChange(input);

    if (!response.succes) {
      throw new Error(response.message || 'Code de verification invalide');
    }
  }
}
